export default "__VITE_ASSET__74e3a628__"